export default "__VITE_ASSET__DuCj4OrM__"